import { Link } from "@tanstack/react-router";
import { Focusable } from "react-aria-components";
import { Tooltip } from "@/components/base/tooltip/tooltip";
import { useMerchant, useWorkspaceId } from "@/providers/MerchantProvider";
import { RuleSignalIcon } from "./rule-signal-icon";

const LINK_CLASSNAME = "inline-flex items-center gap-2 whitespace-nowrap text-sm outline-hidden";

const Label = () => (
  <>
    <RuleSignalIcon className="size-5 text-purple-950" />
    <span className="font-medium text-brand-primary">All rules running</span>
  </>
);

const tooltipCopy = (ruleCount: number) => {
  if (ruleCount === 0) return "Rules are active but haven't taken any action on this collaboration yet.";
  return `${ruleCount} ${ruleCount === 1 ? "rule has" : "rules have"} taken action on this collaboration.`;
};

export const RulesRunningLink = ({ ruleCount }: { ruleCount: number }) => {
  const merchantId = useMerchant();
  const workspaceId = useWorkspaceId();

  return (
    <Tooltip title={tooltipCopy(ruleCount)}>
      <Focusable>
        {workspaceId ? (
          <Link
            to={"/workspace/$workspaceId/merchant/$merchantId/creators/rules" as string}
            params={{ workspaceId, merchantId }}
            className={LINK_CLASSNAME}
          >
            <Label />
          </Link>
        ) : (
          <Link to="/merchant/$merchantId/creators/rules" params={{ merchantId }} className={LINK_CLASSNAME}>
            <Label />
          </Link>
        )}
      </Focusable>
    </Tooltip>
  );
};
